import React, { useState, Component } from 'react';
import { Share2, Twitter, Facebook, Linkedin, Link as LinkIcon, Check } from 'lucide-react';
interface SocialShareProps {
  url: string;
  title: string;
  description?: string;
}
export function SocialShare({
  url,
  title,
  description
}: SocialShareProps) {
  const [showMenu, setShowMenu] = useState(false);
  const [copied, setCopied] = useState(false);
  const shareUrl = encodeURIComponent(url);
  const shareTitle = encodeURIComponent(title);
  const shareDescription = encodeURIComponent(description || '');
  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
      setShowMenu(false);
    }, 2000);
  };
  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
    whatsapp: `https://wa.me/?text=${shareTitle}%20${shareUrl}`
  };
  return <div data-testid="social-share" className="relative" data-id="element-1110">
      <button data-testid="social-share-toggle-btn" onClick={() => setShowMenu(!showMenu)} className="p-2 border border-gray-300 hover:bg-gray-50 flex items-center gap-2" title="Share" data-id="element-1111">
        <Share2 className="w-4 h-4" data-id="element-1112" />
        <span className="text-sm font-medium hidden sm:inline" data-id="element-1113">Share</span>
      </button>

      {showMenu && <>
          <div data-testid="social-share-overlay" className="fixed inset-0 z-40" onClick={() => setShowMenu(false)} data-id="element-1114"></div>
          <div data-testid="social-share-menu" className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 shadow-lg z-50" data-id="element-1115">
            <div className="p-2 space-y-1" data-id="element-1116">
              <a data-testid="social-share-twitter-link" href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 text-sm" data-id="element-1117">
                <Twitter className="w-4 h-4" data-id="element-1118" />
                Twitter
              </a>
              <a data-testid="social-share-facebook-link" href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 text-sm" data-id="element-1119">
                <Facebook className="w-4 h-4" data-id="element-1120" />
                Facebook
              </a>
              <a data-testid="social-share-linkedin-link" href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 text-sm" data-id="element-1121">
                <Linkedin className="w-4 h-4" data-id="element-1122" />
                LinkedIn
              </a>
              <a data-testid="social-share-whatsapp-link" href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 text-sm" data-id="element-1123">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" data-id="element-1124">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-1125" />
                </svg>
                WhatsApp
              </a>
              <button data-testid="social-share-copy-link-btn" onClick={handleCopyLink} className="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 text-sm w-full text-left" data-id="element-1126">
                {copied ? <>
                    <Check className="w-4 h-4 text-green-600" data-id="element-1127" />
                    <span className="text-green-600" data-id="element-1128">Copied!</span>
                  </> : <>
                    <LinkIcon className="w-4 h-4" data-id="element-1129" />
                    Copy Link
                  </>}
              </button>
            </div>
          </div>
        </>}
    </div>;
}